import { Component, OnInit } from '@angular/core';
import { HomeService } from '../services/home.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-articles',
  templateUrl: './articles.component.html',
  styleUrls: ['./articles.component.css']
})
export class ArticlesComponent implements OnInit {
  articles:any=[]
  title:string=''
  constructor(private homeSvc:HomeService,private activatedRoute:ActivatedRoute) { 
    this.activatedRoute.params.subscribe(params => {
      if (params['type']=='yoga') {
       this.GetArticles('YOGA')
       this.title = 'Yoga for Life'
       
      }
      else{
        this.GetArticles('HEALTH')
        this.title = 'Health'
      }
  });
  }

  ngOnInit() {
    // if(this.activatedRoute.snapshot.params.type=='yoga'){
    //   this.GetArticles('YOGA')
    // }
    // if(this.activatedRoute.snapshot.params.type=='health')
  
    // this.GetArticles('HEALTH')
  }
  GetArticles(type){
    this.homeSvc.getArticles(type).subscribe(res=>{
      console.log(res)
this.articles = res["data"]
    },error=>{

    })
  }

  
}
